export const socialButtons = {
  google: {
    color: '#4285F4',
    text: 'white',
  },
  facebook: {
    color: '#4267B2',
    text: 'white',
  },
}
